/**
 * Botao de PIX da sacola — Eletrika (25/09/2026).
 *
 * POR QUE ISTO E UM ASSET E NAO UM <script> NO SNIPPET:
 * o codigo vivia dentro de cart-summary.liquid, que so renderiza quando o carrinho
 * TEM item. Quando a pagina abria com o carrinho vazio e o cliente adicionava um
 * produto, a gaveta era atualizada pela Section Rendering API -- e o navegador NAO
 * executa <script> inserido via innerHTML. O botao aparecia sem comportamento e o
 * primeiro clique nao fazia nada; so depois de recarregar a pagina funcionava.
 * Como asset carregado pelo layout, roda uma vez por pagina, sempre.
 *
 * O QUE ELE FAZ:
 *  - botao de PIX  -> grava o atributo de carrinho vindi_pix_flow=1, aplica o cupom
 *    e vai para o checkout. A Payment Customization da Vindi le esse atributo e
 *    deixa so o PIX no checkout.
 *  - "Finalizar a compra" -> APAGA o atributo antes de enviar, senao quem escolheu
 *    cartao cai num checkout so com PIX (o atributo fica gravado no carrinho).
 *
 * Tudo por delegacao no document: a gaveta e redesenhada a cada mudanca de item, e
 * um listener presoated ao botao se perderia no primeiro redesenho.
 */
(function () {
  'use strict';

  if (window.__eletrikaPix) return;
  window.__eletrikaPix = true;

  function atualizarAtributo(valor, semEsperar) {
    var opcoes = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { vindi_pix_flow: valor } })
    };
    // 29/09: keepalive deixa a requisicao terminar mesmo depois que a pagina sai.
    // E o que permite limpar o atributo SEM segurar o cliente no clique.
    if (semEsperar) opcoes.keepalive = true;
    return fetch('/cart/update.js', opcoes);
  }

  // ---------- "Finalizar a compra": limpa o atributo e segue ----------
  document.addEventListener(
    'click',
    function (e) {
      var c = e.target.closest && e.target.closest('[data-checkout-normal]');
      if (!c) return;

      /*
        29/09: NAO seguramos mais o clique. Antes esperavamos a resposta de
        /cart/update.js antes de navegar, e essa chamada leva ~1,3s no ar (medido:
        741ms a 1829ms) -- o cliente clicava e ficava parado olhando o botao.
        Agora a limpeza sai em paralelo, com keepalive, e o clique segue seu
        caminho normal (sem preventDefault): o formulario de checkout e enviado
        na hora.

        O atributo so existe em carrinho que passou pelo botao de PIX, que hoje
        esta desligado -- isso aqui e rede de seguranca para carrinho antigo.
      */
      try { atualizarAtributo('', true).catch(function () {}); } catch (err) {}
    },
    true
  );

  // ---------- botao de PIX ----------
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pix-botao]');
    if (!b || b.classList.contains('is-loading')) return;
    e.preventDefault();

    var code = b.getAttribute('data-code');
    var destino = b.getAttribute('data-redirect') || '/checkout';
    var reserva = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destino);
    var wrap = b.closest('[data-pix-wrap]');
    var erro = wrap && wrap.querySelector('[data-pix-erro]');
    if (erro) erro.hidden = true;

    b.classList.add('is-loading');
    b.setAttribute('aria-busy', 'true');

    // se algo travar, o caminho antigo assume em 6s -- o cliente nunca fica preso
    var t = setTimeout(function () { window.location.href = reserva; }, 6000);

    atualizarAtributo('1')
      .catch(function () {})
      .then(function () {
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      })
      .then(function (r) {
        clearTimeout(t);
        if (!r || !r.ok) throw new Error('falhou');
        window.location.href = destino;
      })
      .catch(function () {
        clearTimeout(t);
        window.location.href = reserva;
      });
  });
})();
